import { render } from "./detailInfos.vue?vue&type=template&id=7ec92094&scoped=true"
import script from "./detailInfos.vue?vue&type=script&lang=js"
export * from "./detailInfos.vue?vue&type=script&lang=js"

import "./detailInfos.vue?vue&type=style&index=0&id=7ec92094&scoped=true&lang=less"

import exportComponent from "D:\\web\\my\\水茶花\\sch-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec92094"]])

export default __exports__